import { List, ListItem, ListItemIcon } from "@material-ui/core";
import React, { useContext } from "react";
import { useHistory } from "react-router";
import { LoggedUserContext } from "ui/componentes/LoggedUserContext";
import { Routes } from "../../../../routes/Routes";

const Navbar = ({ onClickItem }) => {
    const history = useHistory();
    const loggedUser = useContext(LoggedUserContext);
    return (
        <List>
            {Routes.filter((route) => route.showInMenu)
                .filter((route) => {
                    if (route.roles) {
                        return route.roles.some((role) =>
                            loggedUser.roles.includes(role)
                        );
                    }
                    return true;
                })
                .map((routeObj) => {
                    const { route, label, id, menuIcon: MenuIcon } = routeObj;

                    return (
                        <ListItem
                            key={id}
                            button
                            onClick={() => {
                                history.push(route);
                                onClickItem();
                            }}
                        >
                            <ListItemIcon
                                style={{
                                    minWidth: 35,
                                    fontSize: "0.875rem",
                                    fontWeight: 500,
                                }}
                            >
                                {MenuIcon && <MenuIcon />}
                            </ListItemIcon>
                            {label}
                        </ListItem>
                    );
                })}
        </List>
    );
};

export default Navbar;
